module.exports = __webpack_public_path__ + "img/14.b74b794.png";